module.exports = __webpack_public_path__ + "static/media/background.1d86f2d0.png";